import personRetail from './person-retail.svg';
import personProduction from './person-production.svg';
import personServices from './person-services.svg';
import personTraining from './person-training.svg';

export default {
  personRetail, personProduction, personServices, personTraining,
};



// WEBPACK FOOTER //
// ./src/img/whoCanBFromElla/index.js